import { Component, OnInit } from "@angular/core";
import { Router } from "@angular/router";

@Component({
  selector: "app-my-account",
  templateUrl: "./my-account.component.html",
  styleUrls: ["./my-account.component.scss"],
})
export class MyAccountComponent implements OnInit {
  public userName: string;
  public role: string;
  public profileImg: "assets/images/dashboard/profile.jpg";

  constructor(public router: Router) {
    if (JSON.parse(localStorage.getItem("user"))) {
      const user = JSON.parse(localStorage.getItem("user"));
      this.userName = `${user['firstName']} ${user['lastName']}`
      this.role = `${user['type']}`.toUpperCase()
    } else {
    }
  }

  ngOnInit() {}

  logoutFunc() {
    localStorage.clear()
    this.router.navigateByUrl('auth/login');
  }
}
